<div *ngIf="toasts && toasts.length" class="sh-toast-container">
    <sh-toast *ngFor="let toast of toasts; trackBy: trackToastById" [toast]="toast" (toastClosed)="closeToastById(toast.id)"></sh-toast>
</div>
